import { render, staticRenderFns } from "./moShiDia.vue?vue&type=template&id=144b60f0&scoped=true&"
import script from "./moShiDia.vue?vue&type=script&lang=js&"
export * from "./moShiDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144b60f0",
  null
  
)

export default component.exports